import { API_SECURE_CHAT_BASE_URL } from "@/configs/common"
import { unAuthorizedRequest } from "@/lib/axios"

export interface GetAccessTokenParams {
  wallet_address: string
  signature: string
  message: string
  service_name?: string
}

export const getAvacusProfileApi = async (address: string) => {
  return await unAuthorizedRequest.get(
    `${API_SECURE_CHAT_BASE_URL}/v1/public/users/${address}`
  )
}

export const getNonceApi = async (address: string) => {
  return await unAuthorizedRequest.get(
    `${API_SECURE_CHAT_BASE_URL}/v1/public/users/nonce/?wallet_address=${address}`
  )
}

export const getAccessTokenApi = async (params: GetAccessTokenParams) => {
  return await unAuthorizedRequest.post(
    `${API_SECURE_CHAT_BASE_URL}/v2/public/users/request_auth_token`,
    params
  )
}
